// extracted by mini-css-extract-plugin
module.exports = {"container":"InitLoading_container__1SnRY","loader":"InitLoading_loader__3NJUm","label":"InitLoading_label__1LIUV","subLabel":"InitLoading_subLabel__EfLb0"};